/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsMailOpen: {
  name: 'mail-open';
  data: string;
} = {
  name: 'mail-open',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.971 2.396a2 2 0 0 0-1.942 0l-8 4.444A2 2 0 0 0 2 8.588V20a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8.588a2 2 0 0 0-1.029-1.748l-8-4.444ZM4.642 8.232 12 4.144l7.358 4.088L12 13.75 4.642 8.232ZM4 10.25V20h16v-9.75l-6.8 5.1a2 2 0 0 1-2.4 0L4 10.25Z" fill="currentColor"/></svg>`,
};
